import { useState, useEffect } from 'react';
import AWS from 'aws-sdk';
import useAuthentication from './Authentication';
import useFirebase from '../Firebase';

AWS.config.region = 'eu-central-1';

const useAWSCredentials = () => {
  const firebase = useFirebase();
  const authUser = useAuthentication();
  const [idToken, setIdToken] = useState(undefined);
  useEffect(() => {
    if (authUser && idToken === undefined) {
      console.log(authUser.user);
      authUser.user.getIdToken().then(idToken => {
        setIdToken(idToken);
        let login = {};
        login[`securetoken.google.com/${firebase.projectId}`] = idToken;
        console.debug('authenticating with login ', login);
        AWS.config.credentials = new AWS.CognitoIdentityCredentials(
          {
            IdentityPoolId: 'eu-central-1:adb10fd6-37de-41ba-bcb2-335658b977e2',
            Logins: login
          },
          {
            region: 'eu-central-1'
          }
        );
        console.log('credentials set');
      });
    }
  }, [authUser, idToken]);
};

export default useAWSCredentials;
